import NuevoPeriodo from 'containers/Admin/CrearPeriodo'

export default function CrearPeriodo() {
  return (
    <NuevoPeriodo />
  );
}
